import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}]]

const IconPlayerRecord = createReactComponent('outline', 'player-record', 'PlayerRecord', __iconNode);

export default IconPlayerRecord;